import { ActivityStatus } from 'src/types/dto/activity.dto';

/**
 * Statuses that START the booking-request (n8n) workflow when the tenant has the
 * matching webhook. Any client-side write to one of them must carry
 * `triggerWebhookOnly` so the backend routes it through the locked sync trigger
 * (activity stays at its current status with the in-flight marker set) instead of committing the
 * status and firing the webhook with no lock (CU-86ca54zgj).
 */
export const BOOKING_REQUEST_TRIGGER_STATUSES = new Set<ActivityStatus>([
  ActivityStatus.PRE_REQUESTED,
  ActivityStatus.REQUESTED,
]);

export function isBookingRequestTriggerStatus(status: ActivityStatus | string): boolean {
  return BOOKING_REQUEST_TRIGGER_STATUSES.has(status as ActivityStatus);
}

/** Adds `triggerWebhookOnly: true` to a status-update payload when the status starts a workflow. */
export function withBookingRequestTrigger<T extends { status: ActivityStatus | string }>(
  payload: T
): T & { triggerWebhookOnly?: true } {
  return isBookingRequestTriggerStatus(payload.status)
    ? { ...payload, triggerWebhookOnly: true }
    : payload;
}
